import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faLock } from '@fortawesome/pro-solid-svg-icons/faLock';
import React from 'react';

import PropTypes from 'prop-types';

import { RadioCheckListItem } from 'ui-components/components/radio-check-list/radio-check-list-item';

import style from '../export-records-modal.module.less';

export const DefaultExportFormatOption = ({ format, onFormatTypeChanged, isChecked = false }) => {
  return (
    <RadioCheckListItem
      key={format.extractId}
      className={style['option-row']}
      isChecked={isChecked}
      onChecked={() => onFormatTypeChanged(format.extractId)}
    >
      <div>{format.name}</div>
      <div className={style['option-actions']}>
        <div className={style['lock-wrapper']}>
          <FontAwesomeIcon icon={faLock} />
        </div>
      </div>
    </RadioCheckListItem>
  );
};

DefaultExportFormatOption.propTypes = {
  format: PropTypes.shape({
    extractId: PropTypes.string,
    isChecked: PropTypes.bool,
    name: PropTypes.node,
  }).isRequired,
  onFormatTypeChanged: PropTypes.func.isRequired,
  isChecked: PropTypes.bool,
};
